import { Component, Input, OnInit, OnChanges, Output, EventEmitter, Renderer2, ElementRef  } from '@angular/core';
import { GfTranslateService } from '../../../../core/services/core.translate.service';
import { TrackerService } from '../../services/tracker.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-lock',
  template: require('./trackeritem.lock.component.html')
})
export class TrackerItemLockComponent implements OnInit {
  @Input() lockStatus: any = 0;
  @Input() acls: any;
  @Output() change = new EventEmitter<any>();

  canUpdate: boolean = false;
  lockStatusOptions: any = {};
  isMenuOpen: boolean = false;

  constructor(
    private gfTranslateService: GfTranslateService, 
    private trackerService: TrackerService,
    private renderer: Renderer2,
    private el: ElementRef){}

  ngOnInit() {
    this.init();
  }

  setLockStatus(lockStatus: any) {
    if (lockStatus.value != this.lockStatus) {
      this.lockStatus = lockStatus.value;
      this.change.emit(this.lockStatus);
    }
  }

  isCurrentStatus(lockStatus: any) {
    return this.lockStatus == lockStatus.value;
  }

  private init() {
    this.lockStatusOptions =  {
      id: 'lock_status',
      fieldName: this.gfTranslateService.translate('Lock Status'),
      fieldElements: this.trackerService.fields.builtIn.lock_status.getList()
    };

    this.lockStatus = [0, 1, 2].includes(this.lockStatus) ? this.lockStatus : 0;
    this.canUpdate = !_.isEmpty(this.acls) ? this.acls.canUpdate || this.acls.isAdmin : false;
  }
}
